import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import translate from "../../../../i18n/translate";
import NoDataFound from "../../../shared/NoDataFoundComponent/NoDataFound";
import TestResultCard from "../../../shared/TestResultCard/TestResultCard";
import { getRandomNumber } from "../../../shared/utils/sharedUtils";
import { TestResultsDataInterface } from "../../../../interfaces";
import allActions from "../../../../redux/actions";

interface EmailFeatureSettings {
  emailFeatureName: string;
  status: number | null;
}

interface OrganizationDetail {
  emailFeatureSettings: EmailFeatureSettings[];
}

interface License {
  productId: string;
  productName: string;
  isDemoLicense: boolean | null;
  organizationDetail: OrganizationDetail | null;
  licenseId: string;
  startDate: string;
  endDate: string;
  active: string;
}

const TestResult = () => {
  const dispatch = useDispatch();
  const allInfo = useSelector((state: any) => state);
  const [testResultsList, setTestResultsList] = useState<Array<TestResultsDataInterface> | undefined>([]);
  useEffect(() => {
    if (!allInfo?.testProgress?.isLoading && allInfo?.testProgress?.hasOwnProperty("isLoading")) {
      afterGetTestResultsAPI();
    }
  }, [allInfo.testProgress.isLoading]);

  // The afterGetTestResultsAPI function should be defined elsewhere and optimized if necessary.

  const afterGetTestResultsAPI = () => {
    const { isLoading, isFailed, data } = allInfo.testProgress;
    if (!isLoading && !isFailed && data) {
      const testResults = data["learnerTestResults"] || data;
      setTestResultsList(testResults);
      // handle error page here - false
    } else {
      // handle error page here - true
    }
    if (!isLoading && !isFailed) {
      getSkillsProgress();
    }
  };

  const getSkillsProgress = async () => {
    // License check for sprint business skills
    if (!allInfo.peopleInformation.isFailed && allInfo.peopleInformation.data) {
      let licensesList = allInfo?.peopleInformation?.data?.getpeopleInformation?.license || [];
      const licenseIDList = getOnlyIds(licensesList) || [];
      if (licenseIDList.includes("18") || licenseIDList.includes("29")) {
        if (!allInfo.skillsProgress.data && !allInfo.skillsProgress.isLoading) {
          dispatch(allActions.skillsProgressAction.getSkillsProgress(allInfo.common.leuId));
        }
      }
      getReachProgress();
    }
  };

  const getReachProgress = async () => {
    const { peopleInformation, reachProgress, common } = allInfo;
    // License check for Reach API
    const licensesList = peopleInformation?.data?.getpeopleInformation?.license || [];
    const licenseIDList = getOnlyIds(licensesList);
    if (licenseIDList.includes("15")) {
      const { accountId, token } = peopleInformation.data.getpeopleInformation;
      if (!reachProgress.data && !reachProgress.isLoading) {
        try {
          dispatch(allActions.reachProgressAction.getReachProgress(common.leuId, accountId, token));
        } catch (error) {
          console.error(error);
        }
      }
    }
  };

  const getOnlyIds = (licenseArr: License[]): string[] => {
    const lArr: string[] = [];
    licenseArr.forEach((prod: License) => {
      lArr.push(prod.productId);
    });
    return lArr;
  };

  const hasTestResults = testResultsList && testResultsList.length > 0;
  const productId = allInfo.common.productID;
  return (
    <>
      <div className="test-results-page">
        {hasTestResults ? (
          testResultsList.map((result, index) => (
            <TestResultCard key={getRandomNumber(index)} result={result} productId={productId} />
          ))
        ) : (
          <NoDataFound notProgressPage={true} />
        )}
      </div>
      {hasTestResults && <div className="test-result-msg">{translate("progress_test_result_timer_text")}</div>}
    </>
  );
};

export default TestResult;
